import { create } from 'zustand';
import { ArtistService, type ContactUsPayload } from '@/services/artistService';

interface ContactUsState {
  isSubmitting: boolean;
  error: string | null;
  submitContactUs: (payload: ContactUsPayload) => Promise<void>;
  reset: () => void;
}

const initialState = {
  isSubmitting: false,
  error: null,
};

export const useContactUsStore = create<ContactUsState>()((set) => ({
  ...initialState,

  submitContactUs: async (payload) => {
    set({ isSubmitting: true, error: null });
    try {
      await ArtistService.postContactUs(payload);
    } catch (err: any) {
      const message =
        err instanceof Error
          ? err.message
          : 'Failed to send message. Please try again.';
      set({ error: message });
      throw err;
    } finally {
      set({ isSubmitting: false });
    }
  },

  reset: () => set(initialState),
}));
